// src/components/layout/AppFooter.jsx
import { Box, Stack, Typography, Chip, Tooltip, Link } from "@mui/material";
import { Code, Policy } from "@mui/icons-material";

function AppFooter() {
  const year = new Date().getFullYear();

  // El nombre de la empresa dueña/desarrolladora (ejemplo)
  const companyName = "STX";

  return (
    <Box
      component="footer"
      sx={{
        mt: 3, 
        pt: 1.5,
        pb: 1.5,
        borderTop: "1px solid",
        borderColor: "divider",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1.5,
        bgcolor: 'background.paper',
      }}
    >
      {/* Lado izquierdo: Marca, Copyright y Legalidad */}
      <Stack direction="row" spacing={2.5} alignItems="center">
        
        {/* Nombre de la Aplicación (Primario) */}
        <Typography 
          variant="subtitle2" 
          sx={{ 
            fontWeight: 700, 
            color: "text.primary",
            letterSpacing: '0.5px' 
          }}
        >
          STX Proveedores
        </Typography>
        
        {/* Separador sutil */}
        <Typography variant="caption" color="text.disabled">|</Typography>

        {/* Mención de la empresa dueña/desarrolladora (Contexto B2B) */}
         <Typography variant="caption" color="text.secondary">
             {companyName} © {year}
         </Typography>

        {/* Enlaces Legales */}
        <Stack direction="row" spacing={1.5} alignItems="center">
             <Link href="/terms" variant="caption" color="text.secondary" underline="hover">
                 Términos
             </Link>
             <Link href="/privacy" variant="caption" color="text.secondary" underline="hover">
                 Privacidad
             </Link>
        </Stack>
      </Stack>

      {/* Lado derecho: Metadatos Técnicos (Sutiles) */}
      <Stack direction="row" spacing={1} alignItems="center">
        
        {/* Chip de Versión */}
        <Tooltip title="Versión de la aplicación">
          <Chip
            label="v1.0.0"
            size="small"
            icon={<Code sx={{ fontSize: 14 }} />}
            sx={{ height: 20, fontSize: "0.65rem", borderRadius: 1 }}
            variant="outlined"
          />
        </Tooltip>

        {/* Mención de la Tecnología */}
        <Tooltip title="Tecnología de desarrollo: React & Material UI">
           <Chip
            label="React/MUI"
            size="small"
            icon={<Policy sx={{ fontSize: 14 }} />}
            sx={{
              height: 20, 
              fontSize: "0.65rem", 
              borderRadius: 1, 
              bgcolor: 'rgba(0, 150, 255, 0.1)', 
              color: '#0069c0', 
            }}
          />
        </Tooltip>

      </Stack>
    </Box>
  );
}

export default AppFooter;